export default {
  // Mode
  "common.mode.auto": "Automatisk mode med egenproduceret energi",
  "common.mode.economy": "Økonomisk mode",
  "common.mode.exigency": "Nødmodus",

  // Enheder
  "common.grid": "Elnet",
  "common.evChargers": "Elbiloplader (flere)",
  "common.evCharger": "Elbiloplader",
  "common.pv": "Solceller (PV)",
  "common.inverter": "Omformer (enhed til at ændre spænding)",
  "common.pcs": "Omformer + Batteri",
  "common.terminal": "Terminalenhed",
  "common.airc": "Aircondition (AC)",
  "common.engine": "Motor",
  "common.battery": "Batteri",
  "common.metter": "Elmåler",
  "common.other": "Andet",
  "common.power": "Effekt",
  "common.powerTotal": "Total effekt",
  "common.voltage": "Spænding",
  "common.electricity": "Strøm",
  "common.current": "Strømstærke",
  "common.homeUsage": "Total huslast",
  "common.battery.power": "Batterieffekt",

  // Data
  "common.noDataAvailable": "Der er ingen data tilgængelig lige nu~",
  "common.tips": "Tip",
  "common.reset": "Nulstil",
  "common.currencyUnit": "¥ (Yuan)",
  "common.submiting": "Sender... Vent venligst...",
  "common.close": "Luk",
  "common.from": "Fra",
  "common.useIn": "Til",
  "common.energyPercent": "Energiudnyttelsesprocent",
  "common.dataFlow": "Dataflow",
  "common.getDataIng": "Henter data... Vent venligst...",
  "common.pageLoading": "Indlæser side... Vent venligst...",
  "common.reseting": "Nulstiller side... Vent venligst...",
  "common.save": "Gem",
  "common.onlyNumberTips": "Kun tal kan indtastes",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault": "Fejl (problem)",
  "common.charge": "Lade (batteri)",
  "common.discharge": "Aflevere (brug batterienergi)",
  "common.buy": "Køb",
  "common.sell": "Sælg",
  "common.loadingInfo": "Indlæser... Vent venligst...",

  // Generelle funktioner
  "common.moreFeatures": "Flere funktioner",
  "common.confirm": "Bekræft",
  "common.saveing": "Gemmer... Vent venligst...",
  "common.searchPlacholder": "Indtast søgeord",
  "common.iSee": "Jeg forstår",
  "common.pageErrorTips1": "Åh, der opstod en fejl på siden~",
  "common.pageErrorTips2": "Genindlæs siden eller kontakt support~",
  "common.refresh": "Genindlæs",
  "common.backToHome": "Tilbage til forsiden",
  "common.checkTips": "Checker... Vent venligst...",
  "common.back": "Tilbage",
  "common.cancel": "Annuller (slet)",
  "common.optional": "Valgfri (ikke påkrævet)",
  "common.required": "Påkrævet",
  "common.status": "Status",
  "common.statusNoDelete": "Ikke slettet",
  "common.statusDelete": "Slettet",
  "common.submit": "Indsend",
  "common.disable": "Deaktiver",
  "common.enable": "Aktivér",
  "common.year": "År",
  "common.month": "Måned",
  "common.day": "Dag",
  "common.version": "Version:",
  "common.backHome": "Tilbage til forsiden",
  "common.backHomeSorry": "Undskyld, siden er udelukkende adgangsløs",
  "common.requestTips1": "Datahentning er i gang, send venligst ikke igen",
  "common.requestTips2": "Systembesked",
  "common.requestTips3": "Login-sessionen er udløbet, log venligst ind igen",
  "common.requestTips4": "Log ind igen",
  "common.requestTips5": "Login er ugyldigt eller sessionen er udløbet, log venligst ind igen.",
  "common.requestTips6": "Serverfejl, prøv venligst senere.",
  "common.requestTips7": "Systemanmodningen har udløbet",
  "common.requestTips8": "Systemgrænseflade",
  "common.requestTips9": "Fejl",
  "common.iknow": "Jeg forstår",
  "common.logoutSuccess": "Loggede ud succesfuldt",
  
  // Flere oplysninger
  "common.knowMore.title": "For flere oplysninger, kontakt Beineng",
  "common.knowMore.email": "Email til kontakt",
  "common.knowMore.phone": "Telefonnummer til kontakt",
  "common.knowMore.wechat": "WeChat til kontakt",
  "common.knowMore.website": "Officiell hjemmesideadresse",
  "common.knowMore.address": "Adresse til kontakt",
  "common.knowMore.addressDetail": "Enhed 1205, 1301, Bygning 5, Qinghe 8 vej, Huangjingkeng landsby, Huangjiang distrikt, Dongguan by, Guangdong province",
  
  // Lokal forbindelse
  "common.localConnection": "Lokal forbindelse",
  "common.operateInApp": "Udfør operationer i appen!",
  
  "common.enbleStaus": "Aktiveret status",
  "common.battery.status": "Ikke opladning, ikke afladning",

  // Konto relateret
  "account.forgetThePassword": "Glemt adgangskode",
  "account.logInDirectly": "Log ind direkte",
  "account.tips1": "Vifter side... Vent venligst...",
  "account.tips2": "Læs og accepter først brugsbetingelserne!",
  "account.autoLogin": "Auto-login",
  "account.userLogin": "Brugerlogin",
  "account.registerTips": "Ingen konto? Klik her for at registrere",
  "account.userEmail": "Brugernavn / Email",
  "account.userEmailTips": "Indtast brugernavn eller email",
  "account.password": "Adgangskode",
  "account.passwordTips": "Indtast adgangskode",
  "account.submit": "Indsend",
  "account.submitTips": "Sender... Vent venligst...",
  "account.otherLoginTips": "Eller vælg anden login-metode",
  "account.userRegistration": "Brugerregistrering",
  "account.userName": "Brugernavn",
  "account.userNameTips": "Indtast brugernavn",
  "account.emailTips1": "Indtast email-adresse",
  "account.emailTips2": "Ugyldig email-format",
  "account.phone": "Telefon",
  "account.phoneTips1": "Indtast telefonnummer",
  "account.phoneTips2": "Ugyldigt telefonnummer",
  "account.phoneTips3": "Indtast telefonnummer",
  "account.passwordTips1": "Indtast adgangskode (6-30 tegn)",
  "account.passwordTips2": "Ugyldigt adgangskodeformat: Adgangskoden skal indeholde engelske bogstaver, tal, underscore (_), bindestreg (-) og punktum (.), længde 6-12 tegn",
  "account.passwordTips3": "De to indtastede adgangskoder er ikke ens, tjek venligst og indtast igen!",
  "account.passwordTips4": "Indtast adgangskode: Adgangskoden skal indeholde engelske bogstaver, tal, underscore (_), bindestreg (-) og punktum (.)",
  "account.passwordTips5": "Bekræft adgangskode",
  "account.passwordTips6": "Indtast for at bekræfte adgangskode",
  "account.passwordTips7": "De to indtastede adgangskoder er ikke ens, tjek venligst og indtast igen!",
  "account.passwordTips8": "Indtast for at bekræfte adgangskode",
  "account.passwordTips9": "Tillykke, registreringen var succesfuld!",
  "account.passwordTips10": "Dit brugernavn er:",
  "account.emailIs": "Din email er:",
  "account.goToLoginPage": "Vil blive viftet til login-siden automatisk om s sekunder",
  "account.goLogin": "Log ind",
  "account.goRegister": "Registrer",
  "account.loginSuccess": "Loggede ind succesfuldt",
  "account.email": "Email",
  "account.sologn": "Vi skaber en integreret energplatform specialdesignet til dig",
  "account.pleaseAgree": "Jeg har læst og accepterer",
  "userAgreement.privacyPolicy": "Privatlivspolitik",

  // Verifikationskode relateret
  "account.code": "Verifikationskode",
  "account.codeTips": "Indtast verifikationskode",
  "account.codeTips2": "Ugyldig verifikationskode",

    "account.inviteCodeTips": "Indtast venligst invitationskode",
    "account.inviteCodeHint": "Kontakt venligst installatøren eller driftspersonalet for at få invitationskoden",
  // Adgangskodeændring og gendannelse
  "account.modifyPasswordByAccount": "Ændre adgangskode via konto",
  "account.modifyPasswordByEmail": "Ændre adgangskode via email",
  "account.getPasswordByAccount": "Hent adgangskode via konto",
  "account.getPasswordByEmail": "Hent adgangskode via email",

  "account.sendEmailTips": "Verifikationskoden er sendt til email, tjek venligst",
  "account.name": "Kontonavn",
  "account.newPassword": "Ny adgangskode",
  "account.confirmNewPassword": "Bekræft ny adgangskode",
  "account.nameTips": "Indtast kontonavn",
  "account.passwordModifySuccess": "Adgangskodeændring var succesfuld",
  "account.emailCode": "Email-verifikationskode",
  "account.emailCodeTips": "Indtast email-verifikationskode",
  "account.emailCodeTips2": "Ugyldig email-verifikationskode",
  "account.emailModifySuccess": "Adgangskodeændring var succesfuld",
  "account.passworTips1": "Din adgangskode er blevet nulstillet!",
  "account.passwordTips11": "Indtast for at bekræfte adgangskode",
  "account.passwordTips12": "Indtast ny adgangskode",
  "account.nickname": "Kaldenavn",
  "account.modifyNickname": "Ændre kaldenavn",
  "account.modifyNicknameSuccess": "Kaldenavnændring var succesfuld!",
  "account.nicknameTips": "Indtast kaldenavn",
  "account.nicknameError": "Kaldenavnændring mislykkedes!",

  // Hurtig registrering og login
  "account.login": "Log ind",
  "account.quickRegister": "Hurtig registrering",
  "account.sendCode": "Send kode",
  "account.sendTips": "Kan sendes igen om s sekunder",
  "account.sendEmailIng": "Sender email... Vent venligst...",
  "account.emailNotEmpty": "Email-feltet kan ikke være tomt",
  "account.registerAccount": "Kontoregistrering",
  "account.registerWelcome": "Velkommen til SusprSafe-registrering",
  "account.usernameLimit": "Brugernavnet skal starte med en bogstav, kan kun indeholde bogstaver, tal og underscore (_), længde 5-15 tegn",

  // Copyright-informationer
  "copyright.desc2": "Hjemmeside-registreringsoplysninger: Guangdong-provins ICP-registreringsnummer 2021169764",

  // Rediger brugeroplysninger
  "editUserInfo.editUserInformation": "Rediger brugeroplysninger",
  "editUserInfo.modifyUsername": "Ændre brugernavn",
  "editUserInfo.changePictures": "Skift profilbillede",
  "editUserInfo.savePicturesSuccess": "Profilbillede gemt succesfuldt",
  "editUserInfo.saveError": "Gemning mislykkedes",
  "editUserInfo.pictureLimit": "Billedstørrelsen må ikke overstige 2 MB",
  "editUserInfo.uploadPicture": "Upload profilbillede",
  "editUserInfo.picturePreview": "Forhåndsvisning",
  
  "editUserInfo.bindPhoneNumber": "Bind telefonnummer",
  "editUserInfo.bindEmail": "Bind email",
  "editUserInfo.changePassword": "Skift adgangskode",

  "editUserInfo.notificationSettings": "Notifikationsindstillinger",
  "editUserInfo.editAccount": "Rediger kontooplysninger",
  "editUserInfo.waitBingting": "Binder... Vent venligst...",
  "editUserInfo.collapse": "Sammenklap (adskil)",
  "editUserInfo.modifyBinding": "Ændre binding",
  
  "editUserInfo.emailAddress": "Email-adresse",
  "editUserInfo.tips1": "Email-binding var succesfuld",
  "editUserInfo.tips2": "Gemning mislykkedes",
  "editUserInfo.tips3": "Sender email-verifikationskode... Vent venligst...",
  "editUserInfo.tips4": "Verifikationskoden er sendt til email xxxx, tjek venligst",
  "editUserInfo.tips5": "Sendelse af verifikationskode mislykkedes!",
  "editUserInfo.tips6": "Telefonnummeret er blevet bundet",
  "editUserInfo.tips7": "Emailen er blevet bundet",
  "editUserInfo.emailTips1": "Indtast email-adresse",
  "editUserInfo.emailTips2": "Ugyldigt email-format",
  "editUserInfo.emailTips3": "Kan sendes igen om xxxx sekunder",
  "editUserInfo.emailTips4": "Send kode",
  "editUserInfo.emailTips5": "Email-verifikationskode-feltet kan ikke være tomt",
  "editUserInfo.emailTips6": "Ugyldig email-verifikationskode",
  "editUserInfo.emailCode": "Email-verifikationskode",
  "editUserInfo.save": "Gem",

  // Telefonbinding relateret
  "editUserInfo.phoneTips1": "Telefonnummerbinding var succesfuld",
  "editUserInfo.phoneTips2": "Sender SMS-verifikationskode... Vent venligst...",
  "editUserInfo.phoneTips3": "SMS-verifikationskoden er sendt til nummer xxxx, tjek venligst",
  "editUserInfo.phoneTips4": "Sendelse af SMS-verifikationskode mislykkedes!",
  "editUserInfo.phoneTips5": "Indtast telefonnummer",
  "editUserInfo.phoneTips6": "Ugyldigt telefonnummerformat",
  "editUserInfo.phoneTips7": "Send SMS-verifikationskode",
  "editUserInfo.phoneTips8": "SMS-verifikationskode",
  "editUserInfo.phoneTips9": "SMS-verifikationskode-feltet kan ikke være tomt",
  "editUserInfo.phoneTips10": "Ugyldig SMS-verifikationskode",
  "editUserInfo.phone": "Telefonnummer",


  // Notifikationsindstillinger
  "editUserInfo.noticeTips1": "Henting af notifikationsindstillinger mislykkedes!",
  "editUserInfo.noticeTips2": "Notifikationsindstillinger gemt succesfuldt!",
  "editUserInfo.noticeTips3": "Batterinedsvingelsesnotifikation",
  "editUserInfo.noticeTips4": "Opladningsafslutningsnotifikation",
  "editUserInfo.errorNotification": "Fejlnotifikation",
  "editUserInfo.updateNotification": "Opdateringsnotifikation",
  "editUserInfo.monthlyStatisticsNotification": "Månedlige statistiknotifikationer",
  "editUserInfo.notificationMethod": "Modtagelsesmetode",

  // Brugernavn relaterede tips
  "editUserInfo.userNameTips1": "Brugernavn gemt succesfuldt",
  "editUserInfo.userNameTips2": "Brugernavn gemning mislykkedes",
  "editUserInfo.userNameTips3": "Indtast brugernavn",
  "editUserInfo.userNameTips4": "Ugyldigt brugernavnformat: Kan kun indeholde tal, underscore (_) og engelske bogstaver",
  "editUserInfo.userNameTips5": "Indtast brugernavn",
  "editUserInfo.userNameTips6": "Gemmer... Vent venligst...",
  "editUserInfo.userName": "Brugernavn",

  // Profilbillede redigeringstips
  "editUserInfo.avatorTips": "Klik for at skifte profilbillede",
  "editUserInfo.verifyCodeTips1": "Indtast den modtagne verifikationskode:",
  "editUserInfo.verifyCodeTips2": "For din kontosikkerhed, klik på knappen nedenfor for at sende en verifikationskode til det oprindelige telefonnummer:",
  "editUserInfo.verifyCodeTips3": "Send kode",
  "editUserInfo.verifyCodeTips4": "Verifikation af oprindeligt telefonnummer var succesfuld, indtast det nye telefonnummer, der skal bindes",
  "editUserInfo.verifyCodeTips5": "For din kontosikkerhed, klik på knappen nedenfor for at sende en verifikationskode til den oprindelige email:",
  "editUserInfo.verifyCodeTips6": "Verifikation af oprindelig email var succesfuld, indtast ny email",
  "editUserInfo.verifyCodeTips7": "Gamle adgangskode",
  "editUserInfo.verifyCodeTips8": "Først, bind email!",
  "editUserInfo.verifyCodeTips9": "Verifikationskoden er sendt til email, tjek venligst",
  "editUserInfo.verifyCodeTips10": ", vil blive viftet til login-siden automatisk",

  // Notifikation relateret
  "hems.notice.title": "Notifikationstitel", 
  "hems.notice.content": "Notifikationsindhold", 
  "hems.notice.operate": "Operation",
  "hems.notice.noRead": "Ikke læst",
  "hems.notice.read": "Læst",
  "hems.notice.warning": "Advarsel",
  "hems.notice.error": "Fejl",
  "hems.notice.success": "Statistikberegning",
  "hems.notice.sys": "Systemoplysninger",
  "hems.notice.operateSuccess": "Operationen var succesfuld",
  "hems.notice.operateTips": "Vælg element til operation",

  // Forside
  "hems.home.selfuseRate": "Selvbrugs procent",
  "hems.home.percent": "Procent",
  "hems.home.todayData": "Dagens data",
  "hems.home.todayPowerGeneration": "Dagens energiproduktion",
  "hems.home.salesIncome": "Indtægter fra energisalg",
  "hems.home.saved": "Du har sparet",
  "hems.home.reduce": "Reduktion af kulstofaftryk",
  "hems.home.tips1": "Der er ingen data tilgængelig lige nu, du har ikke endnu bundet xxxx",
  "hems.home.criticalLoad": "Kritisk last",
  "hems.home.keyVoltage": "Kritisk spænding",
  "hems.home.householdLoad": "Huslast",
  "hems.home.householdVoltage": "Husspænding",
  "hems.home.generalLoad": "Generel last",
  "hems.home.generalVoltage": "Generel spænding",
  "hems.home.batteryHealth": "Batteri sundhedstilstand",
  "hems.home.averageTemp": "Gennemsnitstemperatur",
  "hems.home.gridLoad": "Elnetlast",
  "hems.home.toggeleDataSource": "De viste data er ændret som følger:",
  "hems.home.toggleTips": "Vil du ændre?",
  "hems.home.modeSending": "Sender modkommando... Vent venligst...",
  "hems.home.modeSuccess": "Modændring sendt succesfuldt!",
  "hems.home.isOnline": "Er online?",
  "hems.home.useStatus": "Brugsstatus",
  "hems.home.workModeText": "Nuværende arbejdsmode:",
  "hems.home.toggleDataSourceText": "De viste data er ændret som følger:",
  "hems.ev.charge.status": "Opladningsstatus",
  "hems.ev.charge.time": "Opladningstid",
  "hems.ev.charge.count": "Faktisk opladningsantal (over tid)",
  "hems.ev.charge.status.empty": "Tom",
  "hems.ev.charge.status.ing": "Bundet til batteri. Oplader",
  "hems.ev.charge.status.null": "Bundet til batteri, men ikke oplader",
  "hems.ev.charge.status.error": "Fejl",
  "hems.hour": "Time",
  "hems.minue": "Minut",
  "hems.ev.chagre.number": "Oplader nummer",

  // Brugermanual
  "hems.userGuide.selfUse": "Brug egenproduceret energi",
  "hems.userGuide.selfUseTips": "Brug først solenergi, hvis den ikke er tilstrækkelig, fyld med elnet",
  "hems.userGuide.economyMode": "Økonomisk mode",
  "hems.userGuide.economyModeTips": "Optimér energibrugsstrategi baseret på elpriser",
  "hems.userGuide.emergencyMode": "Nødmodus",
  "hems.userGuide.emergencyModeTips": "Prioriter energiforsyning til kritiske last",

  // Grafside
  "hems.history.energyStatistics": "Energistatistik",
  "hems.history.revenueStatistics": "Indtægtsstatistik",
  "hems.history.greenStatistics": "Grøn nedbringelse af emissioner",
  "hems.history.revenueTitle": "Total indtægter fra energisalg",
  "hems.history.savingsTitle": "Total besparelse",
  "hems.history.carbonTitle": "Total kulstofreducering",
  "hems.history.day": "Dag",
  "hems.history.month": "Måned",
  "hems.history.year": "År",
  "hems.history.beforeDay": "Forrige dag",
  "hems.history.afterDay": "Næste dag",
  "hems.history.beforeMonth": "Forrige måned",
  "hems.history.afterMonth": "Næste måned",
  "hems.history.beforeYear": "Forrige år",
  "hems.history.afterYear": "Næste år",
  "hems.history.totalUse": "Total brug",
  "hems.history.fullScreen": "Fuldskærm",
  "hems.history.timeSelect": "Vælg dag",
  "sync.tips1": "Datasykroniseringskommando sendt succesfuldt!",
  "sync.tips2": "Udfører datasykronisering, tager tid på grund af stort datavolumen, tjek igen om 50 minutter~",
  "sync.tips3": "Enhedens datasykronisering kan være forsinket, hvis du ser inkonsistenser i data, klik på knappen nedenfor:",
  "sync.tips4": "Synkroniser data",

  // Opladeroplysninger
  "charge.info": "Opladeroplysninger",
  "news.loading": "Indlæser...",
  "news.noMore": "Ingen flere data",
  "hems.pv.power": "Solenergymængde",

  // UEH-specifikke funktioner
  "ueh.sellPower": "Mængde energi, der sælges",
  
  // Menu
  "menu.home": "Forside",
  "menu.history": "Historiske data",
  "menu.device": "Enheder",
  "menu.settings": "Indstillinger",
  "menu.messageCenter": "Beskedcenter",
  "menu.help": "Hjælp og support",
  "menu.mine": "Mig (personligt)",


  // Mine indstillinger
  "mine.userSetting": "Brugerindstillinger",
  "mine.terminalSetting": "Grundlæggende terminalindstillinger",
  "mine.uploadCloud": "Upload data til skyen",
  "mine.changeVersion": "Tjek for opdateringer",
  "mine.language": "Skift sprog",
  "mine.about": "Om appen",
  "mine.feedback": "Feedback",
  "mine.logout": "Log ud",
  "mine.logoutAccount": "Slet konto",

  // Slet konto relateret
  "mine.logoutAccountTips": "Slet konto med navn []",
  "mine.logoutAccountTips1": "Slet konto, der er bundet til []",
  "mine.logoutAccountCare": "Bemærkninger til kontosletningsanmodning:",
  "mine.logoutAccountCare1": "1. Kontoen er i sikkert tilstand",
  "mine.logoutAccountCare1-1": "Kontoen er i almindelig brugstilstand, ingen risiko for tyveri, regelforbrud eller lukning",
  "mine.logoutAccountCare2": "2. Kontotilgang og binding slettes",
  "mine.logoutAccountCare2-1": "Alle kontotilgange til tredjepartplatforme slettes",
  "mine.logoutAccountCare3": "3. Efter sletning kan konten ikke gendannes, brugerdata slettes",
  "mine.logoutAccountCare3-1": "Efter sletning slettes telefonnummer, email og relaterede data, der er bundet, kan ikke gendannes",
  "mine.confirmLogout": "Bekræft sletning",
  "mine.logoutSuccess": "Kontoen slettet succesfuldt!",


  // Feedback problemer
  "mine.feedbackIssues": "Problemer og feedback",
  "mine.feedQuantity": "Mængde",
  "mine.feedAmount": "Maksimum 9 billeder, maksimal størrelse pr. billede 1 MB",

  // Notifikationsindstillinger relateret
  "mine.notice.fail": "Henting af notifikationsindstillinger mislykkedes!",
  "mine.notice.saveSuccess": "Notifikationsindstillinger gemt succesfuldt!",
  "mine.notice.saveFail": "Gemning mislykkedes!",
  "mine.notice.title": "Notifikationsindstillinger",
  "mine.notice.batteryLow": "Batterinedsvingelsesnotifikation",
  "mine.notice.chargingFinish": "Opladningsafslutningsnotifikation",
  "mine.notice.error": "Fejlnotifikation",
  "mine.notice.update": "Opdateringsnotifikation",
  "mine.notice.monthly": "Månedlige statistiknotifikationer",
  "mine.notice.receiveType": "Modtagelsesmetode",

  // Sprogindstillingsvelkomst
  "mine.language.welcome": "Velkommen til SusprSafe",
  "mine.language.desc1": "Vælg sprogversion efter dit hjemsted",
  "mine.language.desc2": "Du kan skifte den når som helst i appens indstillinger",

  // Personlige oplysninger
  "mine.userInfo.avatar": "Profilbillede",
  "mine.userInfo.nickname": "Kaldenavn",
  "mine.userInfo.password": "Adgangskode",
  "mine.userInfo.changePassword": "Skift adgangskode",
  "mine.userInfo.setPassword": "Indstil adgangskode",
  "mine.userInfo.phoneNumber": "Telefonnummer",
  "mine.userInfo.bindPhone": "Bind telefon",
  "mine.userInfo.bindEmail": "Bind email",
  "mine.loginExpired": "Login-sessionen er udløbet, log venligst ind igen",
  "mine.userInfo.title": "Brugeroplysninger",
  "mine.userInfo.bind": "Bind",
  "mine.userInfo.modify": "Ændre",
  "mine.userInfo.modifyNickname": "Ændre kaldenavn",
  "mine.userInfo.userNickname": "Brugerkaldenavn",
  "mine.userInfo.selectPic": "Vælg billede til upload",
  "mine.userInfo.saveSuccess": "Gemning succesfuld",
  "mine.userInfo.uploadFail": "Upload mislykkedes",
  "mine.userInfo.avatarSaveSuccess": "Profilbillede gemt succesfuldt",
  "mine.userInfo.nameTips1": "Kaldenavn-feltet kan ikke være tomt",
  "mine.userInfo.nameTips2": "Indtast kaldenavn",

  // Generelle vælgelsestips
  "common.pleaseSelect": "Vælg venligst",
  "question.commonQuestions": "Ofte stillede spørgsmål",
  "account.toggleLanguage": "Skift sprog",
  "account.localConnection": "Lokal forbindelse",
  "account.selectLanguage": "Vælg venligst sprog",
  "account.sendEmailToast": "Verifikationskoden er sendt til email xxx, tjek venligst",
  "account.emailError": "Ugyldigt email-format",
  "account.sendEmailFail": "Sendelse mislykkedes, prøv venligst igen",
  
  "common.submitting": "Sender... Vent venligst...",

  "device.page.noData": "Der er ingen data tilgængelig lige nu, denne side kan kun vises i appen"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};